import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection">
      {/* TOP BRAND STRIP */}
      <div className="bg-primary py-5 text-white">
        <div className="container text-center">
          <h2 className="font-bold mb-3">Contact Kitchen Kings TZ</h2>
          <p className="mb-0 opacity-75" style={{ fontSize: "1.05rem" }}>
            Talk to us. Visit us. Build with confidence.
          </p>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="bg-secondary bg-opacity-10 py-5">
        <div className="container">
          {/* CONTACT ACTIONS */}
          <div className="row g-4 mb-5">
            {/* PHONE */}
            <div className="col-md-4">
              <div className="bg-white h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaPhoneAlt size={26} className="text-primary" />
                  <h5 className="font-bold mb-0 text-primary">Telephone</h5>
                </div>
                <a
                  href="tel:+255679101107"
                  className="d-block text-decoration-none text-dark mb-1"
                >
                  +255 (0) 679 101 107
                </a>
                <a
                  href="tel:+255719423242"
                  className="d-block text-decoration-none text-dark"
                >
                  +255 (0) 719 423 242
                </a>
              </div>
            </div>

            {/* WHATSAPP */}
            <div className="col-md-4">
              <div className="bg-primary text-white h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaWhatsapp size={28} />
                  <h5 className="font-bold mb-0">WhatsApp</h5>
                </div>
                <p className="opacity-75 mb-2">
                  Instant communication with our team
                </p>
                <a
                  href="https://wa.me/255679101107"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-light btn-sm rounded-pill px-4"
                >
                  Chat Now
                </a>
              </div>
            </div>

            {/* EMAIL */}
            <div className="col-md-4">
              <div className="bg-white h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaEnvelope size={26} className="text-primary" />
                  <h5 className="font-bold mb-0 text-primary">Email</h5>
                </div>
                <a
                  href="mailto:info@kitchenkings.co.tz"
                  className="text-decoration-none text-dark"
                >
                  info@kitchenkings.co.tz
                </a>
              </div>
            </div>
          </div>

          {/* LOCATIONS */}
          <div className="row g-4">
            {/* HEAD OFFICE */}
            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaMapMarkerAlt size={26} className="text-secondary" />
                  <h5 className="font-bold mb-0 text-secondary">Head Office</h5>
                </div>
                <p className="mb-0 text-muted" style={{ lineHeight: 1.8 }}>
                  P.O. Box 3362<br />
                  Rock City Mall<br />
                  Makongoro Road<br />
                  Mwanza, Tanzania<br />
                  East Africa
                </p>
              </div>
            </div>

            {/* GEITA BRANCH */}
            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaMapMarkerAlt size={26} className="text-secondary" />
                  <h5 className="font-bold mb-0 text-secondary">Geita Branch</h5>
                </div>
                <p className="mb-0 text-muted" style={{ lineHeight: 1.8 }}>
                  P.O. Box 3362<br />
                  Soko Kuu La Dhahabu<br />
                  Geita, Tanzania
                </p>
              </div>
            </div>
          </div>

          {/* FOOTER STRIP */}
          <div className="row mt-5">
            <div className="col">
              <div className="bg-primary text-white text-center py-3 rounded-pill">
                <small className="opacity-75">
                  Serving Tanzania & East Africa | Business • Residential • Commercial
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
